/**
 * Canonical UI timestamp: the instant in the viewer's browser timezone, 24-hour clock and no
 * timezone suffix, e.g. "28 Oct 2026, 10:27" (docs/ui-ux-guidelines.md → "Local Time"; ENT-6192).
 * Calendar-only dates keep their own formatter so they never shift with the timezone.
 */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  const date = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  return `${date}, ${time}`;
}
